import language from './language';
import date from './date';
import number from './number';
/**
 * Bridge: A way to communicate between the client (App) and the I18nspect tool (chrome extension / mobile floating button)
 */
var bridge = {
    language: language,
    date: date,
    number: number,
};
export default bridge;
